function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M95.687,248.5H47.59c-4.142,0-7.5,3.358-7.5,7.5v48.097c0,4.142,3.358,7.5,7.5,7.5h48.097c4.142,0,7.5-3.358,7.5-7.5    s-3.358-7.5-7.5-7.5H55.09V263.5h33.097v8.532c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5V256    C103.187,251.858,99.829,248.5,95.687,248.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.848,248.5h-48.097c-4.142,0-7.5,3.358-7.5,7.5v48.097c0,4.142,3.358,7.5,7.5,7.5h48.097c4.142,0,7.5-3.358,7.5-7.5    V256C183.348,251.858,179.99,248.5,175.848,248.5z M168.348,296.597h-33.097V263.5h33.097V296.597z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256.009,248.5h-48.097c-4.142,0-7.5,3.358-7.5,7.5v48.097c0,4.142,3.358,7.5,7.5,7.5h48.097c4.142,0,7.5-3.358,7.5-7.5    V256C263.509,251.858,260.151,248.5,256.009,248.5z M248.509,296.597h-33.097V263.5h33.097V296.597z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.687,408.823H47.59c-4.142,0-7.5,3.358-7.5,7.5v48.097c0,4.142,3.358,7.5,7.5,7.5h48.097c4.142,0,7.5-3.358,7.5-7.5    v-48.097C103.187,412.181,99.829,408.823,95.687,408.823z M88.187,456.919H55.09v-33.097h33.097V456.919z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.848,408.823h-48.097c-4.142,0-7.5,3.358-7.5,7.5v48.097c0,4.142,3.358,7.5,7.5,7.5h48.097c4.142,0,7.5-3.358,7.5-7.5    v-48.097C183.348,412.181,179.99,408.823,175.848,408.823z M168.348,456.919h-33.097v-33.097h33.097V456.919z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256.009,408.823h-48.097c-4.142,0-7.5,3.358-7.5,7.5v48.097c0,4.142,3.358,7.5,7.5,7.5h48.097c4.142,0,7.5-3.358,7.5-7.5    v-48.097C263.509,412.181,260.151,408.823,256.009,408.823z M248.509,456.919h-33.097v-33.097h33.097V456.919z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.687,328.661H47.59c-4.142,0-7.5,3.358-7.5,7.5v48.097c0,4.142,3.358,7.5,7.5,7.5h48.097c4.142,0,7.5-3.358,7.5-7.5    v-48.097C103.187,332.019,99.829,328.661,95.687,328.661z M88.187,376.758H55.09v-33.097h33.097V376.758z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.848,328.661h-48.097c-4.142,0-7.5,3.358-7.5,7.5v48.097c0,4.142,3.358,7.5,7.5,7.5h48.097c4.142,0,7.5-3.358,7.5-7.5    v-48.097C183.348,332.019,179.99,328.661,175.848,328.661z M168.348,376.758h-33.097v-33.097h33.097V376.758z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256.009,328.661h-48.097c-4.142,0-7.5,3.358-7.5,7.5v48.097c0,4.142,3.358,7.5,7.5,7.5h48.097c4.142,0,7.5-3.358,7.5-7.5    v-48.097C263.509,332.019,260.151,328.661,256.009,328.661z M248.509,376.758h-33.097v-33.097h33.097V376.758z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M308.43,124.224c1.406,1.407,3.314,2.197,5.303,2.197s3.897-0.79,5.303-2.197l34.01-34.01    c1.407-1.406,2.197-3.314,2.197-5.303s-0.79-3.897-2.197-5.303l-34.01-34.009c-2.929-2.929-7.678-2.929-10.606,0l-34.009,34.009    c-2.929,2.929-2.929,7.678,0,10.606L308.43,124.224z M313.733,61.508l23.403,23.403l-23.403,23.403l-23.403-23.403L313.733,61.508    z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M331.104,146.896l34.009,34.01c1.406,1.407,3.314,2.197,5.303,2.197s3.897-0.79,5.303-2.197l34.01-34.01    c1.407-1.406,2.197-3.314,2.197-5.303s-0.79-3.897-2.197-5.303l-34.01-34.009c-2.929-2.929-7.678-2.929-10.606,0l-34.009,34.009    C328.174,139.219,328.174,143.968,331.104,146.896z M370.416,118.19l23.403,23.403l-23.403,23.403l-23.403-23.403L370.416,118.19z    "
}), /*#__PURE__*/React.createElement("path", {
  d: "M432.402,158.963c-2.929-2.929-7.678-2.929-10.606,0l-34.009,34.009c-2.929,2.929-2.929,7.678,0,10.606l34.009,34.01    c1.406,1.407,3.314,2.197,5.303,2.197s3.897-0.79,5.303-2.197l34.01-34.01c1.407-1.406,2.197-3.314,2.197-5.303    s-0.79-3.897-2.197-5.303L432.402,158.963z M427.099,221.679l-23.403-23.403l23.403-23.403l23.403,23.403L427.099,221.679z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M205.672,158.963c-2.929-2.929-7.678-2.929-10.606,0l-19.589,19.589c-2.929,2.929-2.929,7.678,0,10.606    c2.929,2.929,7.678,2.929,10.606,0l14.286-14.286l14.286,14.286c1.464,1.464,3.384,2.197,5.303,2.197s3.839-0.732,5.303-2.197    c2.929-2.929,2.929-7.678,0-10.606L205.672,158.963z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M298.561,141.593c0-1.989-0.79-3.897-2.197-5.303l-34.01-34.009c-2.929-2.929-7.678-2.929-10.606,0l-34.009,34.009    c-2.929,2.929-2.929,7.678,0,10.606l34.009,34.01c1.406,1.407,3.314,2.197,5.303,2.197s3.897-0.79,5.303-2.197l34.01-34.01    C297.771,145.49,298.561,143.583,298.561,141.593z M257.051,164.997l-23.403-23.403l23.403-23.403l23.403,23.403L257.051,164.997z    "
}), /*#__PURE__*/React.createElement("path", {
  d: "M375.719,215.646c-1.406-1.407-3.314-2.197-5.303-2.197s-3.897,0.79-5.303,2.197l-34.009,34.01    c-2.929,2.929-2.929,7.678,0,10.606l34.009,34.01c1.406,1.407,3.314,2.197,5.303,2.197s3.897-0.79,5.303-2.197l34.01-34.01    c2.929-2.929,2.929-7.678,0-10.606L375.719,215.646z M370.416,278.362l-23.403-23.403l23.403-23.403l23.403,23.403    L370.416,278.362z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M333.458,286.75c-2.929-2.93-7.678-2.929-10.606,0c-2.929,2.929-2.929,7.678,0,10.606l14.285,14.285l-14.285,14.286    c-2.929,2.929-2.929,7.678,0,10.606c1.464,1.464,3.384,2.197,5.303,2.197s3.839-0.732,5.303-2.197l19.589-19.589    c1.407-1.406,2.197-3.314,2.197-5.303s-0.79-3.897-2.197-5.303L333.458,286.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M322.851,212.561c-2.929,2.929-2.929,7.678,0,10.606c1.464,1.464,3.384,2.197,5.303,2.197s3.839-0.732,5.303-2.197    l19.589-19.589c1.407-1.406,2.197-3.314,2.197-5.303s-0.79-3.897-2.197-5.303l-34.01-34.009c-2.929-2.929-7.678-2.929-10.606,0    l-19.589,19.589c-2.929,2.929-2.929,7.678,0,10.606c2.929,2.929,7.678,2.929,10.606,0l14.286-14.286l23.403,23.403    L322.851,212.561z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M500.421,170.299L341.71,11.588C334.237,4.116,324.302,0,313.733,0c-10.568,0-20.503,4.116-27.976,11.588L127.046,170.299    c-10.143,10.143-13.753,24.803-10.253,38.12h-77.22c-21.816,0-39.564,17.749-39.564,39.564v224.452    C0.009,494.251,17.758,512,39.574,512h224.452c21.816,0,39.564-17.749,39.564-39.564V395.2c3.309,0.87,6.696,1.325,10.082,1.325    c10.238,0,20.416-3.939,28.038-11.561l158.711-158.711C515.847,210.826,515.847,185.726,500.421,170.299z M264.025,497H39.574    c-13.545,0-24.564-11.02-24.564-24.564V247.984c0-13.545,11.02-24.564,24.564-24.564h224.452c13.545,0,24.564,11.02,24.564,24.564    v224.452C288.59,485.98,277.57,497,264.025,497z M489.815,215.646L331.103,374.357c-7.296,7.296-18.351,9.144-27.513,4.995    V247.984c0-21.816-17.749-39.564-39.564-39.564H132.659c-4.15-9.162-2.303-20.217,4.994-27.514L296.364,22.195    c4.64-4.64,10.809-7.195,17.37-7.195c6.562,0,12.73,2.555,17.37,7.195l158.711,158.711    C499.392,190.484,499.392,206.068,489.815,215.646z"
}));

var SvgWaffle = function SvgWaffle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2A975"
    },
    d: "M495.118,175.603L336.407,16.892c-12.522-12.522-32.824-12.522-45.346,0L132.349,175.603    c-12.522,12.522-12.522,32.824,0,45.346L291.061,379.66c12.522,12.522,32.824,12.522,45.346,0l158.711-158.711    C507.64,208.427,507.64,188.125,495.118,175.603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D19A6E"
    },
    d: "M154.845,215.281c-9.392-9.391-9.392-24.618,0-34.01L326.107,10.01    c-11.645-4.87-25.568-2.596-35.046,6.882L132.349,175.603c-12.522,12.522-12.522,32.824,0,45.346L291.061,379.66    c9.478,9.478,23.401,11.751,35.046,6.882L154.845,215.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D19A6E"
    },
    d: "M194.7,226.617l-22.673-22.673c-3.13-3.13-3.13-8.206,0-11.337l22.673-22.673    c3.13-3.13,8.206-3.13,11.337,0l22.673,22.673c3.13,3.13,3.13,8.206,0,11.337l-22.673,22.673    C202.906,229.748,197.831,229.748,194.7,226.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C38C66"
    },
    d: "M228.71,192.608l-22.673-22.673c-3.13-3.13-8.206-3.13-11.337,0l-5.668,5.668l11.337,11.337    c6.261,6.261,6.261,16.412,0,22.673l-11.337,11.337l5.668,5.668c3.13,3.13,8.206,3.13,11.337,0l22.673-22.673    C231.84,200.814,231.84,195.738,228.71,192.608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D19A6E"
    },
    d: "M251.383,169.935l-22.673-22.673c-3.13-3.13-3.13-8.206,0-11.337l22.673-22.673    c3.13-3.13,8.206-3.13,11.337,0l22.673,22.673c3.13,3.13,3.13,8.206,0,11.337l-22.673,22.673    C259.589,173.065,254.513,173.065,251.383,169.935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C38C66"
    },
    d: "M285.392,135.925l-22.673-22.673c-3.13-3.13-8.206-3.13-11.337,0l-5.668,5.668l11.337,11.337    c6.261,6.261,6.261,16.412,0,22.673l-11.337,11.337l5.668,5.668c3.13,3.13,8.206,3.13,11.337,0l22.673-22.673    C288.523,144.131,288.523,139.056,285.392,135.925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D19A6E"
    },
    d: "M308.065,113.252l-22.673-22.673c-3.13-3.13-3.13-8.206,0-11.337l22.673-22.673    c3.13-3.13,8.206-3.13,11.337,0l22.673,22.673c3.13,3.13,3.13,8.206,0,11.337l-22.673,22.673    C316.271,116.383,311.196,116.383,308.065,113.252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C38C66"
    },
    d: "M342.075,79.243L319.402,56.57c-3.13-3.13-8.206-3.13-11.337,0l-5.668,5.668l11.337,11.337    c6.261,6.261,6.261,16.412,0,22.673l-11.337,11.337l5.668,5.668c3.13,3.13,8.206,3.13,11.337,0l22.673-22.673    C345.205,87.449,345.205,82.373,342.075,79.243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D19A6E"
    },
    d: "M308.065,226.617l-22.673-22.673c-3.13-3.13-3.13-8.206,0-11.337l22.673-22.673    c3.13-3.13,8.206-3.13,11.337,0l22.673,22.673c3.13,3.13,3.13,8.206,0,11.337l-22.673,22.673    C316.271,229.748,311.196,229.748,308.065,226.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C38C66"
    },
    d: "M342.075,192.608l-22.673-22.673c-3.13-3.13-8.206-3.13-11.337,0l-5.668,5.668l11.337,11.337    c6.261,6.261,6.261,16.412,0,22.673l-11.337,11.337l5.668,5.668c3.13,3.13,8.206,3.13,11.337,0l22.673-22.673    C345.205,200.814,345.205,195.738,342.075,192.608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D19A6E"
    },
    d: "M364.748,169.935l-22.673-22.673c-3.13-3.13-3.13-8.206,0-11.337l22.673-22.673    c3.13-3.13,8.206-3.13,11.337,0l22.673,22.673c3.13,3.13,3.13,8.206,0,11.337l-22.673,22.673    C372.954,173.065,367.878,173.065,364.748,169.935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C38C66"
    },
    d: "M398.757,135.925l-22.673-22.673c-3.13-3.13-8.206-3.13-11.337,0l-5.668,5.668l11.337,11.337    c6.261,6.261,6.261,16.412,0,22.673l-11.337,11.337l5.668,5.668c3.13,3.13,8.206,3.13,11.337,0l22.673-22.673    C401.888,144.131,401.888,139.056,398.757,135.925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D19A6E"
    },
    d: "M308.065,339.982l-22.673-22.673c-3.13-3.13-3.13-8.206,0-11.336l22.673-22.673    c3.13-3.13,8.206-3.13,11.337,0l22.673,22.673c3.13,3.13,3.13,8.206,0,11.336l-22.673,22.673    C316.271,343.113,311.196,343.113,308.065,339.982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C38C66"
    },
    d: "M342.075,305.973L319.402,283.3c-3.13-3.13-8.206-3.13-11.337,0l-5.668,5.668l11.337,11.337    c6.261,6.261,6.261,16.412,0,22.673l-11.337,11.337l5.668,5.668c3.13,3.13,8.206,3.13,11.337,0l22.673-22.673    C345.205,314.179,345.205,309.103,342.075,305.973z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D19A6E"
    },
    d: "M364.748,283.3l-22.673-22.673c-3.13-3.13-3.13-8.206,0-11.337l22.673-22.673    c3.13-3.13,8.206-3.13,11.337,0l22.673,22.673c3.13,3.13,3.13,8.206,0,11.337L376.084,283.3    C372.954,286.43,367.878,286.43,364.748,283.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C38C66"
    },
    d: "M398.757,249.29l-22.673-22.673c-3.13-3.13-8.206-3.13-11.337,0l-5.668,5.668l11.337,11.337    c6.261,6.261,6.261,16.412,0,22.673l-11.337,11.336l5.668,5.668c3.13,3.13,8.206,3.13,11.337,0l22.673-22.673    C401.888,257.496,401.888,252.421,398.757,249.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D19A6E"
    },
    d: "M421.43,226.617l-22.673-22.673c-3.13-3.13-3.13-8.206,0-11.337l22.673-22.673    c3.13-3.13,8.206-3.13,11.336,0l22.673,22.673c3.13,3.13,3.13,8.206,0,11.337l-22.673,22.673    C429.636,229.748,424.561,229.748,421.43,226.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C38C66"
    },
    d: "M455.44,192.608l-22.673-22.673c-3.13-3.13-8.206-3.13-11.336,0l-5.668,5.668l11.337,11.337    c6.261,6.261,6.261,16.412,0,22.673l-11.337,11.337l5.668,5.668c3.13,3.13,8.206,3.13,11.336,0l22.673-22.673    C458.57,200.814,458.57,195.738,455.44,192.608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE09F"
    },
    d: "M264.025,215.919H39.574c-17.709,0-32.065,14.356-32.065,32.064v224.451    c0,17.709,14.356,32.065,32.065,32.065h224.451c17.709,0,32.065-14.356,32.065-32.065V247.984    C296.09,230.275,281.734,215.919,264.025,215.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6D190"
    },
    d: "M87.671,464.419H55.606c-4.427,0-8.016-3.589-8.016-8.016v-32.065c0-4.427,3.589-8.016,8.016-8.016    h32.065c4.427,0,8.016,3.589,8.016,8.016v32.065C95.687,460.83,92.098,464.419,87.671,464.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBD83"
    },
    d: "M87.671,416.323H55.606c-4.427,0-8.016,3.589-8.016,8.016v8.016h16.032    c8.854,0,16.032,7.178,16.032,16.032v16.032h8.016c4.427,0,8.016-3.589,8.016-8.016v-32.065    C95.687,419.912,92.098,416.323,87.671,416.323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6D190"
    },
    d: "M87.671,384.258H55.606c-4.427,0-8.016-3.589-8.016-8.016v-32.065c0-4.427,3.589-8.016,8.016-8.016    h32.065c4.427,0,8.016,3.589,8.016,8.016v32.065C95.687,380.669,92.098,384.258,87.671,384.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBD83"
    },
    d: "M87.671,336.161H55.606c-4.427,0-8.016,3.589-8.016,8.016v8.016h16.032    c8.854,0,16.032,7.178,16.032,16.032v16.032h8.016c4.427,0,8.016-3.589,8.016-8.016v-32.065    C95.687,339.75,92.098,336.161,87.671,336.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6D190"
    },
    d: "M87.671,304.097H55.606c-4.427,0-8.016-3.589-8.016-8.016v-32.065c0-4.427,3.589-8.016,8.016-8.016    h32.065c4.427,0,8.016,3.589,8.016,8.016v32.065C95.687,300.508,92.098,304.097,87.671,304.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBD83"
    },
    d: "M87.671,256H55.606c-4.427,0-8.016,3.589-8.016,8.016v8.016h16.032    c8.854,0,16.032,7.178,16.032,16.032v16.032h8.016c4.427,0,8.016-3.589,8.016-8.016v-32.065C95.687,259.589,92.098,256,87.671,256    z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6D190"
    },
    d: "M167.832,464.419h-32.065c-4.427,0-8.016-3.589-8.016-8.016v-32.065    c0-4.427,3.589-8.016,8.016-8.016h32.065c4.427,0,8.016,3.589,8.016,8.016v32.065C175.848,460.83,172.259,464.419,167.832,464.419    z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBD83"
    },
    d: "M167.832,416.323h-32.065c-4.427,0-8.016,3.589-8.016,8.016v8.016h16.032    c8.854,0,16.032,7.178,16.032,16.032v16.032h8.016c4.427,0,8.016-3.589,8.016-8.016v-32.065    C175.848,419.912,172.259,416.323,167.832,416.323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6D190"
    },
    d: "M167.832,384.258h-32.065c-4.427,0-8.016-3.589-8.016-8.016v-32.065    c0-4.427,3.589-8.016,8.016-8.016h32.065c4.427,0,8.016,3.589,8.016,8.016v32.065    C175.848,380.669,172.259,384.258,167.832,384.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBD83"
    },
    d: "M167.832,336.161h-32.065c-4.427,0-8.016,3.589-8.016,8.016v8.016h16.032    c8.854,0,16.032,7.178,16.032,16.032v16.032h8.016c4.427,0,8.016-3.589,8.016-8.016v-32.065    C175.848,339.75,172.259,336.161,167.832,336.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6D190"
    },
    d: "M167.832,304.097h-32.065c-4.427,0-8.016-3.589-8.016-8.016v-32.065    c0-4.427,3.589-8.016,8.016-8.016h32.065c4.427,0,8.016,3.589,8.016,8.016v32.065    C175.848,300.508,172.259,304.097,167.832,304.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBD83"
    },
    d: "M167.832,256h-32.065c-4.427,0-8.016,3.589-8.016,8.016v8.016h16.032    c8.854,0,16.032,7.178,16.032,16.032v16.032h8.016c4.427,0,8.016-3.589,8.016-8.016v-32.065    C175.848,259.589,172.259,256,167.832,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6D190"
    },
    d: "M247.993,464.419h-32.064c-4.427,0-8.016-3.589-8.016-8.016v-32.065    c0-4.427,3.589-8.016,8.016-8.016h32.064c4.427,0,8.016,3.589,8.016,8.016v32.065C256.009,460.83,252.42,464.419,247.993,464.419z    "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBD83"
    },
    d: "M247.993,416.323h-32.064c-4.427,0-8.016,3.589-8.016,8.016v8.016h16.032    c8.854,0,16.032,7.178,16.032,16.032v16.032h8.016c4.427,0,8.016-3.589,8.016-8.016v-32.065    C256.009,419.912,252.42,416.323,247.993,416.323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6D190"
    },
    d: "M247.993,384.258h-32.064c-4.427,0-8.016-3.589-8.016-8.016v-32.065    c0-4.427,3.589-8.016,8.016-8.016h32.064c4.427,0,8.016,3.589,8.016,8.016v32.065C256.009,380.669,252.42,384.258,247.993,384.258    z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBD83"
    },
    d: "M247.993,336.161h-32.064c-4.427,0-8.016,3.589-8.016,8.016v8.016h16.032    c8.854,0,16.032,7.178,16.032,16.032v16.032h8.016c4.427,0,8.016-3.589,8.016-8.016v-32.065    C256.009,339.75,252.42,336.161,247.993,336.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6D190"
    },
    d: "M247.993,304.097h-32.064c-4.427,0-8.016-3.589-8.016-8.016v-32.065    c0-4.427,3.589-8.016,8.016-8.016h32.064c4.427,0,8.016,3.589,8.016,8.016v32.065C256.009,300.508,252.42,304.097,247.993,304.097    z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBD83"
    },
    d: "M247.993,256h-32.064c-4.427,0-8.016,3.589-8.016,8.016v8.016h16.032    c8.854,0,16.032,7.178,16.032,16.032v16.032h8.016c4.427,0,8.016-3.589,8.016-8.016v-32.065    C256.009,259.589,252.42,256,247.993,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6D190"
    },
    d: "M51.473,484.585c-13.282,0-24.048-10.767-24.048-24.048v-242.2    c-11.678,4.791-19.915,16.244-19.915,29.648v224.451c0,17.708,14.355,32.065,32.064,32.065h224.451    c13.404,0,24.857-8.238,29.648-19.915H51.473z"
  })), _ref2));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWaffle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/waffle.f7122522.svg";
export { ForwardRef as ReactComponent };